document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.circle-category-grid').forEach((root) => {
    initFilter(root);
    initSort(root);
  });
});

function initFilter(root) {
  const buttons = root.querySelectorAll('.circle-category-grid__index-item');
  const items = root.querySelectorAll('.circle-category-grid__item');

  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.filter;

      buttons.forEach((b) => b.classList.remove('is-active'));
      button.classList.add('is-active');

      items.forEach((item) => {
        const matches = filter === 'all' || item.dataset.category === filter;
        item.classList.toggle('is-hidden', !matches);
      });
    });
  });
}

function initSort(root) {
  const sortButtons = root.querySelectorAll('.circle-category-grid__sort-option');
  const grid = root.querySelector('.circle-category-grid__grid');

  if (!sortButtons.length || !grid) return;

  sortButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const sortType = button.dataset.sort;
      const items = Array.from(grid.querySelectorAll('.circle-category-grid__item'));

      sortButtons.forEach((b) => b.classList.remove('is-active'));
      button.classList.add('is-active');

      items.sort((a, b) => {
        if (sortType === 'manual') {
          return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
        }

        if (sortType === 'new') {
          const aNew = a.dataset.isNew === 'true' ? 0 : 1;
          const bNew = b.dataset.isNew === 'true' ? 0 : 1;
          if (aNew !== bNew) return aNew - bNew;
          return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
        }

        const aTitle = (a.dataset.title || '').toLowerCase();
        const bTitle = (b.dataset.title || '').toLowerCase();

        if (sortType === 'az') return aTitle.localeCompare(bTitle);
        if (sortType === 'za') return bTitle.localeCompare(aTitle);

        return 0;
      });

      items.forEach((item) => grid.appendChild(item));
    });
  });
}
